// src/components/partner/PartnerProtectedRoute.js
// Protected route wrapper for partner portal pages

import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePartnerAuth } from '../../contexts/PartnerAuthContext';

const PartnerProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = usePartnerAuth();

  if (loading) {
    return (
      <div className="partner-portal">
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--partner-bg-primary)'
        }}>
          <div className="partner-loading">
            <div className="partner-spinner"></div>
            <div className="partner-loading-text">Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/partner/login" replace />;
  }

  return children;
};

export default PartnerProtectedRoute;
